import React, { Component } from 'react';
import { Label, Row, Col, Input, Button, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';


class CompanyDateToDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId: parseInt(this.props.selector) > 0 ? this.props.selector : 0,
            dateMin: '',
            dateMax: '',
            data: [],
            sheetData: [],
            clientList: this.props.filterClients()
        };
        this.accessors = ['date', 'securities', 'accounts', 'reconciled', 'unreconciled']
    }

    componentDidMount() {
        this.props.log('CompanyDateToDate.js/componentDidMount');
        if (this.state.clientId > 0) this.onSubmit();
        this.props.filterClientsCallback(() => {
            this.setState({
                clientList: this.props.filterClients()
            })
        });
    }

    onSubmit = () => {
        this.props.log('CompanyDateToDate.js/onSubmit');
        fetch('/api/reports/CompanyDateToDateReconStatusReport', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'clientId', type: 'int', value: this.state.clientId },
                { key: 'dateMin', type: 'date', value: (this.state.dateMin !== "" && this.state.dateMin != null ? this.state.dateMin : '1970-01-01') },
                { key: 'dateMax', type: 'date', value: (this.state.dateMax !== "" && this.state.dateMax != null ? this.state.dateMax : '2040-12-31') }
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('CompanyDateToDate.js/getCSVdata');
        const retArr = [['Date', 'New Securities', 'New Accounts', 'Reconciled', 'Unreconciled']].concat(
            this.state.data.map(row => {
                let retArray = [];
                this.accessors.forEach((accessor, index) => {
                    retArray[index] = row[accessor];
                });
                return retArray;
            })
        );
        const name = this.state.data[0] != null && this.state.data[0].name != null ? this.state.data[0].name.replace(' ', '-') : '';
        this.props.passData(retArr, "company-date-to-date_" + name);
    }

    onChange = (e) => {
        this.props.log('CompanyDateToDate.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.props.changeSelector(e);
        this.setState({ clientId: e.target.value })
    }

    render() {
        this.props.info('CompanyDateToDate.js/render');
        return (
            <><Row className="mb-4 noPrint">
                <Col md={4} className="px-1">
                    <Label className="w-100">Company
                        <Input type="select" className="companySelect" name="clientId" value={this.props.isFieldNull(this.state.clientId)} onChange={this.onChange}>
                            <option value="0">Select</option>
                            {this.state.clientList.map(client => (
                                <option key={client.id} value={this.props.isFieldNull(client.id)}>{client.client}</option>
                            ))}
                        </Input>
                    </Label>
                </Col>
                <Col md={3} className="px-1">
                    <Label className="w-100">Date from
                        <Input type="date" name="dateMin" value={this.props.isFieldNull(this.state.dateMin)} onChange={(e) => this.setState({ dateMin: e.target.value })} />
                    </Label>
                </Col>
                <Col md={3} className="px-1">
                    <Label className="w-100">Date to
                        <Input type="date" name="dateMax" value={this.props.isFieldNull(this.state.dateMax)} onChange={(e) => this.setState({ dateMax: e.target.value })} />
                    </Label>
                </Col>
                <Col md={2} className="pt-2">
                    <Button className="align-items-end" color="primary" onClick={this.onSubmit}>Run Report</Button>
                </Col>
            </Row>
                {this.state.data.length > 0 ?
                    <><Row><h2>{this.state.data[0].name}</h2></Row>
                        <Row><Table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>New Securities</th>
                                    <th>New Accounts</th>
                                    <th>Reconciled</th>
                                    <th>Unreconciled</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.map(row => (
                                    <tr key={row.id}>
                                        <td>{parseInt(row.date.substr(5, 2)) + '/' + parseInt(row.date.substr(8, 2)) + '/' + row.date.substr(2, 2)}</td>
                                        <td>{row.securities}</td>
                                        <td>{row.accounts}</td>
                                        <td>{row.reconciled}</td>
                                        <td>{row.unreconciled}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table></Row>
                        {/* <Row>
                            <CSVLink
                                className="btn btn-primary"
                                data={this.getCSVdata()}
                                filename={"rbo-report_company-date-to-date_" + this.state.data[0].name.replace(' ', '-') + ".csv"}
                            >Download CSV</CSVLink>
                        </Row> */}
                    </>
                    : <>No results</>}
            </>
        );

    }
}

export default CompanyDateToDate;
